import axios from '@/axiosInterceptor.js';
const state = () => ({
  searchResults: {
    records: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalRecords: 0,
    },
  },
});

// getters
const getters = {};

// actions
const actions = {
  async search({ commit }, { searchText, page }) {
    console.log(`Params: ${searchText}`);
    var params = {
      page: page,
      'q[legal_name_search_not_null]': 1,
      'q[latest_census_id_or_identifiers_verified_by_not_null]': 1,
    };
    if (searchText) {
      searchText = searchText?.toUpperCase();
      if (/^[\s0-9]*$/.test(searchText)) {
        params['q[identifiers_value_non_padded_start]'] = parseInt(searchText);
        params['q[s]'] = 'legal_name_search asc';
      } else if (/^MC[\s0-9]*$/.test(searchText)) {
        params['q[identifiers_value_non_padded_start]'] = parseInt(
          searchText.replace(/\D/g, '')
        );
        params['q[identifiers_is_type_eq]'] = 'MC';
        params['q[s]'] = 'legal_name_search asc';
      } else if (/^MC-[\s0-9]*$/.test(searchText)) {
        params['q[identifiers_value_non_padded_start]'] = parseInt(
          searchText.replace(/\D/g, '')
        );
        params['q[identifiers_is_type_eq]'] = 'MC';
        params['q[s]'] = 'legal_name_search asc';
      } else if (/^MC [\s0-9]*$/.test(searchText)) {
        params['q[identifiers_value_non_padded_start]'] = parseInt(
          searchText.replace(/\D/g, '')
        );
        params['q[identifiers_is_type_eq]'] = 'MC';
        params['q[s]'] = 'legal_name_search asc';
      } else if (/^DOT[\s0-9]*$/.test(searchText)) {
        params['q[identifiers_value_non_padded_start]'] = parseInt(
          searchText.replace(/\D/g, '')
        );
        params['q[identifiers_is_type_eq]'] = 'DOT';
        params['q[s]'] = 'legal_name_search asc';
      } else if (/^DOT-[\s0-9]*$/.test(searchText)) {
        params['q[identifiers_value_non_padded_start]'] = parseInt(
          searchText.replace(/\D/g, '')
        );
        params['q[identifiers_is_type_eq]'] = 'DOT';
        params['q[s]'] = 'legal_name_search asc';
      } else if (/^DOT [\s0-9]*$/.test(searchText)) {
        params['q[identifiers_value_non_padded_start]'] = parseInt(
          searchText.replace(/\D/g, '')
        );
        params['q[identifiers_is_type_eq]'] = 'DOT';
        params['q[s]'] = 'legal_name_search asc';
      } else if (/^MX[\s0-9]*$/.test(searchText)) {
        params['q[identifiers_value_non_padded_start]'] = parseInt(
          searchText.replace(/\D/g, '')
        );
        params['q[identifiers_is_type_eq]'] = 'MX';
        params['q[s]'] = 'legal_name_search asc';
      } else if (/^MX-[\s0-9]*$/.test(searchText)) {
        params['q[identifiers_value_non_padded_start]'] = parseInt(
          searchText.replace(/\D/g, '')
        );
        params['q[identifiers_is_type_eq]'] = 'MX';
        params['q[s]'] = 'legal_name_search asc';
      } else if (/^MX [\s0-9]*$/.test(searchText)) {
        params['q[identifiers_value_non_padded_start]'] = parseInt(
          searchText.replace(/\D/g, '')
        );
        params['q[identifiers_is_type_eq]'] = 'MX';
        params['q[s]'] = 'legal_name_search asc';
      } else if (/^FF[\s0-9]*$/.test(searchText)) {
        params['q[identifiers_value_non_padded_start]'] = parseInt(
          searchText.replace(/\D/g, '')
        );
        params['q[identifiers_is_type_eq]'] = 'FF';
        params['q[s]'] = 'legal_name_search asc';
      } else if (/^FF-[\s0-9]*$/.test(searchText)) {
        params['q[identifiers_value_non_padded_start]'] = parseInt(
          searchText.replace(/\D/g, '')
        );
        params['q[identifiers_is_type_eq]'] = 'FF';
        params['q[s]'] = 'legal_name_search asc';
      } else if (/^FF [\s0-9]*$/.test(searchText)) {
        params['q[identifiers_value_non_padded_start]'] = parseInt(
          searchText.replace(/\D/g, '')
        );
        params['q[identifiers_is_type_eq]'] = 'FF';
        params['q[s]'] = 'legal_name_search asc';
      } else if (/^SCAC[\s0-9]*$/.test(searchText)) {
        params['q[identifiers_value_non_padded_start]'] = parseInt(
          searchText.replace(/\D/g, '')
        );
        params['q[identifiers_is_type_eq]'] = 'SCAC';
        params['q[s]'] = 'legal_name_search asc';
      } else if (/^SCAC-[\s0-9]*$/.test(searchText)) {
        params['q[identifiers_value_non_padded_start]'] = parseInt(
          searchText.replace(/\D/g, '')
        );
        params['q[identifiers_is_type_eq]'] = 'SCAC';
        params['q[s]'] = 'legal_name_search asc';
      } else if (/^SCAC [\s0-9]*$/.test(searchText)) {
        params['q[identifiers_value_non_padded_start]'] = parseInt(
          searchText.replace(/\D/g, '')
        );
        params['q[identifiers_is_type_eq]'] = 'SCAC';
        params['q[s]'] = 'legal_name_search asc';
      } else if (/^CVOR[\s0-9-]*$/.test(searchText)) {
        params['q[identifiers_value_non_padded_start]'] = searchText
          .replaceAll('-', '')
          .replace(/^CVOR\s?/, '');
        params['q[identifiers_is_type_eq]'] = 'CVOR';
        params['q[s]'] = 'legal_name_search asc';
      } else if (/^(NIR\s?)?[A-Z]-?\d{6}-?\d$/.test(searchText)) {
        const cleanedInput = searchText
          .replace(/^NIR\s?/, '')
          .replace(/^([A-Z])-?/, '$1');
        const cleanedValue = cleanedInput.replace(/-/g, '');
        params['q[identifiers_value_non_padded_start]'] = cleanedValue;
        params['q[identifiers_is_type_eq]'] = 'NIR_QC';
        params['q[s]'] = 'legal_name_search asc';
      } else if (/^NSC_?([A-Z]{2})?\s?\d+(-\d+)*$/.test(searchText)) {
        const cleanedValue = searchText
          .replace(/^NSC_?[A-Z]{2}?\s?/, '')
          .replace('NSC', '')
          .replace(/^(\d+-?\d*)$/, '$1')
          .trim();
        const provinceCodeMatch = searchText.match(/^NSC_?([A-Z]{2})?\s?/);
        const provinceCode =
          provinceCodeMatch && provinceCodeMatch[1]
            ? provinceCodeMatch[1]
            : null;
        params['q[identifiers_value_non_padded_start]'] = cleanedValue;
        if (provinceCode) {
          params['q[identifiers_is_type_eq]'] =
            'NSC' + (provinceCode ? '_' + provinceCode : '');
        }
        params['q[s]'] = 'legal_name_search asc';
      } else if (/^[0-9-]+$/.test(searchText)) {
        params['q[identifiers_value_eq]'] = searchText;
        params['q[s]'] = 'legal_name_search asc';
      } else {
        // Search the predicate columns
        params['q[legal_name_search_or_dba_name_search_start]'] = searchText
          ?.replace(/[^a-z0-9]/gi, '')
          ?.toUpperCase();
        params['q[s]'] = 'legal_name_search asc';
      }
    }
    try {
      const storedSearchResultURL = sessionStorage.getItem('searchResultURL');

      const currentSearchURL =
        process.env.API_MONITOR +
        `/api/v1/carriers/global_search_for_highway_carrier?` +
        new URLSearchParams(params).toString();

      if (storedSearchResultURL === currentSearchURL) {
        console.log('Using cached search results');
        const searchResults = JSON.parse(
          sessionStorage.getItem('searchResults')
        );
        const searchResultsPagination = JSON.parse(
          sessionStorage.getItem('searchResultsPagination')
        );

        commit('setSearch', searchResults);
        commit('setPagination', searchResultsPagination);
        return;
      }

      const res = await axios.get(
        process.env.API_MONITOR +
          `/api/v1/carriers/global_search_for_highway_carrier`,
        {
          params: params,
        }
      );
      if (res) {
        commit('setSearch', res?.data);
        commit('setPagination', res?.headers);

        sessionStorage.setItem('searchResults', JSON.stringify(res.data));
        sessionStorage.setItem(
          'searchResultsPagination',
          JSON.stringify(res.headers)
        );
        sessionStorage.setItem('searchResultURL', currentSearchURL);
      }
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

// mutations
const mutations = {
  setSearch(state, data) {
    state.searchResults.records = data;
  },
  setPagination(state, headers) {
    state.searchResults.pagination = {
      currentPage: parseInt(headers.currentpage),
      totalPages: parseInt(headers.totalpages),
      totalRecords: parseInt(headers.totalitems),
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
